import { FunctionComponent } from "react";

export const MahleLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/mahle.svg"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="Mahle"
    />
  );
};
